import React from 'react';
import Services from '../Services/Services';
import './Home.css';


const Home = () => {

    return (
        // services 
        <div>
           
            
            <Services></Services>
            
            
        </div>
    );
};

export default Home;